import { useState } from 'react';
import rootAxios from '../requests/rootAxios';

const useEmailVerification = () => {
  const [verificationState, setVerificationState] = useState({
    loading: false,
    verified: false,
    error: null,
  });

  const verifyEmails = async (emails, type = 'ch') => {
    if (!emails || emails.length === 0) {
      setVerificationState({
        loading: false,
        verified: false,
        error: 'No emails provided for verification',
      });
      return;
    }

    setVerificationState({
      loading: true,
      verified: false,
      error: null,
    });

    try {
      const response = await rootAxios.post('/user/get-approval-authority', {
        type,
        emails,
      });

      setVerificationState({
        loading: false,
        verified: true,
        error: null,
      });

      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Verification failed';

      setVerificationState({
        loading: false,
        verified: false,
        error: errorMessage,
      });

      throw error;
    }
  };

  const resetVerification = () => {
    setVerificationState({
      loading: false,
      verified: false,
      error: null,
    });
  };

  return {
    verifyEmails,
    resetVerification,
    loading: verificationState.loading,
    verified: verificationState.verified,
    error: verificationState.error,
  };
};

export default useEmailVerification;
